import { useParams } from "react-router-dom";

export const useCityParams = () => useParams<{ cityId: string; }>();